import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w, html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { metricsTrack } from '../../utilities/analytics/index.js';
import '../../atoms/buttons/enums.js';
import '../../utilities/dom-helpers/index.js';
import css_248z from './styles/form-selector.scss.js';
import '../../atoms/buttons/generic-button2.0/index.js';

const LitElementWithUtils = BaseWithUtils(s);
class FormSelector extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.expandedStep = 0;
        this.selectedKeys = {};
    }
    get parsedData() {
        if (!this.data)
            return undefined;
        try {
            return JSON.parse(this.data);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('[form-selector] Failed to parse data attribute', e);
            return undefined;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        metricsTrack('cevt_form_view', {
            dlv_event_category: 'form',
            dlv_event_action: 'view',
            dlv_form_name: this.formName,
            dlv_form_type: this.formName,
            dlv_form_id: this.formId,
        });
    }
    resolveStepCounterText(raw, current, total) {
        return raw
            .replace('[currentstep]', String(current + 1))
            .replace('[stepcount]', String(total))
            .replace('[X]', String(current + 1))
            .replace('[Y]', String(total));
    }
    get allAnswered() {
        if (!this.parsedData)
            return false;
        return this.parsedData.steps.every((_, i) => this.selectedKeys[i] !== undefined);
    }
    resolveSelectedLabel(step, stepIndex) {
        var _a, _b;
        const key = this.selectedKeys[stepIndex];
        if (!key)
            return '';
        return (_b = (_a = step.options.find(o => o.answerKey === key)) === null || _a === void 0 ? void 0 : _a.displayText) !== null && _b !== void 0 ? _b : '';
    }
    handleOptionClick(stepIndex, answerKey) {
        this.selectedKeys = Object.assign(Object.assign({}, this.selectedKeys), { [stepIndex]: answerKey });
        metricsTrack('cevt_form_step', {
            dlv_event_category: 'form',
            dlv_event_action: 'step',
            dlv_form_name: this.formName,
            dlv_form_id: this.formId,
            dlv_form_step: String(stepIndex + 1),
            dlv_form_answer: answerKey,
        });
        if (!this.parsedData)
            return;
        const isLast = stepIndex === this.parsedData.steps.length - 1;
        if (!isLast) {
            this.expandedStep = stepIndex + 1;
        }
        else {
            setTimeout(() => {
                var _a, _b;
                (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.fs-footer')) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 100);
        }
    }
    handleEdit(stepIndex) {
        this.expandedStep = stepIndex;
    }
    handleGetResults() {
        if (!this.parsedData)
            return;
        const selectedSet = new Set(Object.values(this.selectedKeys));
        const result = this.parsedData.results.find(r => r.combinations.some(combo => {
            const comboSet = new Set(combo.split('+').map(k => k.trim()));
            if (comboSet.size !== selectedSet.size)
                return false;
            return [...comboSet].every(k => selectedSet.has(k));
        }));
        if (!(result === null || result === void 0 ? void 0 : result.targetPageUrl)) {
            // eslint-disable-next-line no-console
            console.warn('[form-selector] No result found for combination:', [...selectedSet].join('+'));
            return;
        }
        metricsTrack('cevt_form_complete', {
            dlv_event_category: 'form',
            dlv_event_action: 'complete',
            dlv_form_name: this.formName,
            dlv_form_id: this.formId,
            dlv_form_outcome: result.outcomeKey,
        });
        window.location.href = result.targetPageUrl;
    }
    renderOptionImage(opt) {
        var _a;
        if (!opt.imageUrl)
            return w;
        return $ `<img class="fs-card__image" src="${opt.imageUrl}" alt="${(_a = opt.imageAltText) !== null && _a !== void 0 ? _a : ''}">`;
    }
    renderOption(opt, stepIndex) {
        const isSelected = this.selectedKeys[stepIndex] === opt.answerKey;
        return $ `<label class="fs-option-label ${isSelected ? 'is-selected' : ''}" @click="${() => this.handleOptionClick(stepIndex, opt.answerKey)}" @keydown="${(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.handleOptionClick(stepIndex, opt.answerKey);
            }
        }}"><input class="fs-option" type="radio" name="step-${stepIndex}" .value="${opt.answerKey}" ?checked="${isSelected}"><div class="fs-card">${this.renderOptionImage(opt)} <span class="fs-card__title">${opt.displayText}</span></div></label>`;
    }
    renderStepSelectedAnswer(selectedLabel) {
        return $ `<span class="fs-step__selected-answer">${selectedLabel}</span>`;
    }
    renderStepEditButton(stepTitle, stepIndex) {
        const handleEditClick = (e) => {
            e.stopPropagation();
            this.handleEdit(stepIndex);
        };
        return $ `<button class="fs-step__edit" aria-label="Edit ${stepTitle}" @click="${handleEditClick}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg></button>`;
    }
    renderStepHeader(step, stepIndex, isExpanded, isAnswered, isPending, selectedLabel) {
        const showCollapsedContent = isAnswered && !isExpanded;
        const headerClass = showCollapsedContent
            ? 'fs-step__header fs-step__header--answered'
            : 'fs-step__header';
        const titleClass = isPending
            ? 'fs-step__title fs-step__title--pending'
            : 'fs-step__title';
        const handleHeaderClick = showCollapsedContent
            ? () => this.handleEdit(stepIndex)
            : w;
        return $ `<div class="${headerClass}" @click="${handleHeaderClick}"><div class="fs-step__header-left"><span class="${titleClass}">${step.title}</span> ${showCollapsedContent ? this.renderStepSelectedAnswer(selectedLabel) : w}</div>${showCollapsedContent ? this.renderStepEditButton(step.title, stepIndex) : w}</div>`;
    }
    renderStepBody(step, stepIndex, data) {
        return $ `<div class="fs-step__body"><p class="fs-step__counter">${this.resolveStepCounterText(data.stepXOfYText, stepIndex, data.steps.length)}</p><p class="fs-question">${step.question}</p><div class="fs-options" role="group" aria-label="${step.question}">${step.options.map(opt => this.renderOption(opt, stepIndex))}</div></div>`;
    }
    renderStep(step, stepIndex, data) {
        const isExpanded = this.expandedStep === stepIndex;
        const isAnswered = this.selectedKeys[stepIndex] !== undefined;
        const isPending = !isAnswered && !isExpanded;
        const selectedLabel = this.resolveSelectedLabel(step, stepIndex);
        return $ `<div class="fs-step ${isExpanded ? 'fs-step--expanded' : ''}">${this.renderStepHeader(step, stepIndex, isExpanded, isAnswered, isPending, selectedLabel)} ${this.renderStepBody(step, stepIndex, data)}</div>`;
    }
    render() {
        var _a, _b;
        if (!((_a = this.parsedData) === null || _a === void 0 ? void 0 : _a.steps.length))
            return w;
        return $ `<form class="fs-form ${(_b = this.utilityClasses) !== null && _b !== void 0 ? _b : ''}" @submit="${(e) => e.preventDefault()}">${this.parsedData.steps.map((step, i) => this.renderStep(step, i, this.parsedData))}<div class="fs-footer"><generic-button-updated type="primary" color="purple" .label="${this.parsedData.getResultsButtonText}" .disabled="${!this.allAnswered}" .onClick="${() => this.handleGetResults()}"></generic-button-updated></div></form>`;
    }
}
FormSelector.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    e({ type: String })
], FormSelector.prototype, "formName", void 0);
__decorate([
    e({ type: String })
], FormSelector.prototype, "formId", void 0);
__decorate([
    e({ type: String })
], FormSelector.prototype, "data", void 0);
__decorate([
    t()
], FormSelector.prototype, "expandedStep", void 0);
__decorate([
    t()
], FormSelector.prototype, "selectedKeys", void 0);
customElements.define('form-selector', FormSelector);
// CPD-ON

export { FormSelector };
